import React from "react";
import LanguageSwitcher from "../../../components/LanguageSwitcher";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

function Header() {
  const { t } = useTranslation();

  return (
    <>
      <section className="header-banner text-center py-5">
        <div className="header-overlay" />
        <div className="position-relative z-1 container">
          <Link to="/">
            <img
              src={`${process.env.PUBLIC_URL}/img/sansad-khel-mahotsav.webp`}
              style={{ width: "150px" }}
            />
          </Link>

          <h1 className="display-4 fw-bold" style={{ color: "wheat" }}>
            {t('website_title')}
          </h1>
          <p className="lead">"{t('website_subtitle')}"</p>
          <div className="d-flex justify-content-center gap-3 mt-4 flex-wrap">
            <LanguageSwitcher />

            <Link to="/login" className="btn btn-success me-2 btn-custom">
              <i className="fas fa-user-plus me-2" />{" "}
              {t("participant_registration")}
            </Link>
            <Link to="/admin" className="btn btn-primary btn-custom">
              <i className="fas fa-user me-2" />
              {t("login_title")}
            </Link>
          </div>
        </div>
      </section>

      {/* <nav className="navbar navbar-expand-lg">
        <div className="container">
          <Link className="navbar-brand" to="/">
            <img
              src={`${process.env.PUBLIC_URL}/img/sansad-khel-mahotsav.webp`}
            />
          </Link>

          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
          >
            <span className="navbar-toggler-icon" />
          </button>

          <div className="collapse navbar-collapse" id="navbarNav">
            <div className="navbar-nav ms-auto d-flex align-items-center">
              <div className="dropdown me-2">
                <LanguageSwitcher />
              </div>
              <Link
                to="/registration"
                className="btn btn-success me-2 btn-custom"
              >
                <i className="fas fa-user-plus me-2" />
                {t("participant_registration")}
              </Link>
              <Link to="/admin" className="btn btn-primary btn-custom">
                <i className="fas fa-user me-2" />
                {t("login_title")}
              </Link>
            </div>
          </div>
        </div>
      </nav> */}
    </>
  );
}

export default Header;
